// extracted by mini-css-extract-plugin
export default {"modal":"ModalOverlay_modal__cX4rP","modal_active":"ModalOverlay_modal_active__vgAub","wrapper":"ModalOverlay_wrapper__sDxw2","close":"ModalOverlay_close__7j4Eh"};